var _style, _path, _g, _path2, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#6DA544;}\n\t.st3{fill:#338AF3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,178.1C4.2,202.7,0,228.8,0,256c0,27.2,4.2,53.3,12.1,77.9L256,345l243.9-11.1 c7.8-24.6,12.1-50.7,12.1-77.9c0-27.2-4.2-53.3-12.1-77.9L256,167L12.1,178.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499.9,178.1L256,167L12.1,178.1c-2.3,7.3-4.3,14.7-6,22.3h499.8C504.2,192.8,502.2,185.4,499.9,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.1,311.7c1.7,7.5,3.7,15,6,22.3l0,0L256,345l243.9-11.1c2.3-7.3,4.3-14.7,6-22.3L6.1,311.7z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,512c114.2,0,210.9-74.8,243.9-178.1H12.1C45.1,437.2,141.8,512,256,512L256,512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,0C141.8,0,45.1,74.8,12.1,178.1l487.8,0C466.9,74.8,370.2,0,256,0L256,0z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117,105.7c0-24,16.9-44,39.4-48.9c-3.5-0.8-7-1.2-10.7-1.2c-27.7,0-50.1,22.4-50.1,50.1s22.4,50.1,50.1,50.1 c3.7,0,7.3-0.4,10.7-1.2C133.8,149.7,117,129.7,117,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.9,128.5l3.4,10.4h11l-8.9,6.4l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.4h11L185.9,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221,128.5l3.4,10.4h11l-8.9,6.4l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.4h11L221,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,128.5l3.4,10.4h11l-8.9,6.4l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.4h11L256,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291,128.5l3.4,10.4h11l-8.9,6.4l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.4h11L291,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326,128.5l3.4,10.4h11l-8.9,6.4l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.4h11L326,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221,92.1l3.4,10.4h11l-8.9,6.5l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.5h11L221,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,92.1l3.4,10.4h11l-8.9,6.5l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.5h11L256,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291,92.1l3.4,10.4h11l-8.9,6.5l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.5h11L291,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326,92.1l3.4,10.4h11l-8.9,6.5l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.5h11L326,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,55.7l3.4,10.4h11l-8.9,6.4l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.4h11L256,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291,55.7l3.4,10.4h11l-8.9,6.4l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.4h11L291,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326,55.7l3.4,10.4h11l-8.9,6.4l3.4,10.4l-8.9-6.4l-8.9,6.4l3.4-10.4l-8.9-6.4h11L326,55.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.16fb152deba20a3b78a82f0bd9f93c58.svg";
export { ForwardRef as ReactComponent };